import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Error from "./Pages/Error";
import Layout from "./components/Layout/Layout";
import Login from "./Pages/Login";
import UserDashboard from "./Pages/UserDashboard";
import Signup from "./Pages/Signup";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./routes/ProtectedRoutes";
import { ToastContainer } from "react-toastify";
import Register from "./Pages/Register";
import OrganizerDashboard from "./Pages/OrganizerDashboard";
import EventDashboard from "./Pages/EventDashboard";
import Event from "./Pages/Event";
import { EventProvider } from "./context/EventContext";

// * The main application component that renders all the routes and the layout of the application.
// * It uses the AuthProvider and EventProvider to provide the authentication and event data to all the components.
// * It renders the Layout component which contains the navigation bar and the routes.
// * It renders the ToastContainer component at the bottom of the page to display the toast messages.
// * It uses the ProtectedRoute component to protect the routes that require authentication.
const App = () => {
  return (
    <>
      <ToastContainer
        position="bottom-center"
        autoClose={200}
        hideProgressBar={true}
        closeOnClick
      />
      <Router>
        <AuthProvider>
          <EventProvider>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/events" element={<Event />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Error />} />
              </Route>
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/register/:emailID" element={<Register />} />
              <Route
                path="/userdashboard/*"
                element={
                  // <ProtectedRoute>
                  <UserDashboard />
                  // </ProtectedRoute>
                }
              />
              <Route
                path="/organizerdashboard/*"
                element={<OrganizerDashboard />}
              />
              <Route
                path="/eventdashboard/*"
                element={
                  <ProtectedRoute>
                    <EventDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </EventProvider>
        </AuthProvider>
      </Router>
    </>
  );
};

export default App;
